<form name="form" [formGroup]="form">
    <div class="row">
        <div class="col-5">
            <div class="upload-img position-relative border border-gray-500 br-15 w-100 h-100">
                <div
                    class="overlay position-absolute w-100 h-100 br-15"
                    *ngIf="uploadImageSrc"
                ></div>
                <div class="text-center">
                    <input
                        formControlName="upload_img"
                        id="imgFile"
                        type="file"
                        class="d-none"
                        (change)="onImgFileChange($event)"
                    />
                    <label for="imgFile" class="upload-img-btn">
                        <span
                            href="javascript:;"
                            class="d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary m-auto"
                        >
                            <img
                                src="./assets/images/icons/common/plus.svg"
                                alt="Upload media"
                                title="Upload media"
                            />
                        </span>
                        <span class="d-block text-center monserrat-medium mt-2">Upload media</span>
                    </label>
                </div>
                <ng-container *ngIf="uploadImageSrc">
                    <div class="text-center d-flex align-items-center justify-content-center h-100">
                        <img [src]="uploadImageSrc" class="img-fluid br-15" />
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="col-7">
            <div class="row">
                <div class="col-12 mb-4">
                    <mat-form-field
                        class="form-group dark-input"
                        [ngClass]="{
                            validationError:
                                form.get('media_title').errors && form.get('media_title').touched
                        }"
                    >
                        <input
                            matInput
                            formControlName="media_title"
                            type="text"
                            placeholder="Media title"
                        />
                    </mat-form-field>
                    <app-error-input [form]="form" [controlName]="'media_title'"> </app-error-input>
                </div>
                <div class="col-12 d-flex justify-content-between align-items-start mb-4">
                    <span class="text-gray mr-5"
                        >Set Your channels list and include a specific rule for each one of
                        them.</span
                    >
                    <div class="d-flex align-items-center justify-content-between flex-grow-1">
                        <mat-checkbox formControlName="all_channels" class="mr-4 montserrat-regular"
                            >All channels</mat-checkbox
                        >
                        <button class="small-action-btn bg-gray-500 text-primary">
                            <img
                                src="./assets/images/icons/common/plus.svg"
                                alt="Add Channel"
                                title="Add Channel"
                            />
                        </button>
                    </div>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="form-group dark-input">
                                <mat-label>Channel</mat-label>
                                <mat-select
                                    formControlName="channel"
                                    panelClass="select-panel-down"
                                    [disableOptionCentering]="true"
                                >
                                    <mat-option
                                        *ngFor="let channel of channels"
                                        [value]="channel.value"
                                        class="text-capitalize"
                                    >
                                        {{ channel.label }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="form-group dark-input">
                                <mat-label>Rule</mat-label>
                                <mat-select
                                    formControlName="rule"
                                    panelClass="select-panel-down"
                                    [disableOptionCentering]="true"
                                >
                                    <mat-option
                                        *ngFor="let rule of rules"
                                        [value]="rule.value"
                                        class="text-capitalize"
                                    >
                                        {{ rule.label }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
